export default {
  system: {
    name: '관리 시스템',
    language: '언어',
    theme: '테마'
  },
  auth: {
    login: '로그인',
    adminPanel: '관리자 패널',
    phone: '전화번호',
    password: '비밀번호',
    signIn: '로그인',
    logout: '로그아웃',
    confirmLogout: '로그아웃 확인',
    confirmLogoutText: '정말 로그아웃하시겠습니까?',
    loginError: '로그인에 실패했습니다. 이메일과 비밀번호를 확인해주세요.',
    forgotPassword: '로그인 방법을 모르거나 비밀번호를 잊어버린 경우,',
    contactSupport: 'Lockerbot 회사에 문의하세요:'
  },
  dashboard: {
    title: '대시보드',
    user: '사용자',
    goodMorning: '좋은 아침입니다',
    goodAfternoon: '좋은 오후입니다',
    goodEvening: '좋은 저녁입니다',
    welcomeMessage: 'LockerBot 관리자 패널에 오신 것을 환영합니다. 여기서 패키지, 사용자 및 설정을 관리할 수 있습니다.',
    profile: '내 프로필',
    profileTitle: '사용자 프로필',
    viewAllActive: '모든 활성 보기',
    viewAllExpired: '모든 만료된 패키지 보기',
    viewAllFinished: '모든 완료된 패키지 보기',
    totalUsers: '총 사용자',
    totalPackages: '총 패키지',
    activePackages: '활성 패키지',
    deliveredToday: '오늘 배송됨',
    totalCells: '총 셀',
    cellsUsage: '사용 중인 셀',
    averageDailyUsage: '일일 평균 사용량',
    cellsUsageChart: '셀 사용량 차트',
    recentPackages: '최근 패키지',
    activeUsers: '활성 사용자',
    lastActive: '마지막 활동',
    lockedPackages: '잠긴 패키지',
    expiredPackages: '만료됨',
    finishedPackages: '완료됨',
    currentlyStored: '현재 저장 중',
    storageExpired: '저장 시간 만료',
    successfullyDelivered: '성공적으로 배송됨',
    users: '사용자',
    lockersStatus: '락커 상태',
    totalLockers: '총 락커',
    onlineLockers: '온라인',
    offlineLockers: '오프라인',
    maintenanceLockers: '유지보수',
    errorLockers: '오류',
    cellsStatus: '셀 상태',
    activeCells: '활성',
    brokenCells: '고장',
    occupiedCells: '사용 중',
    reservedCells: '예약됨',
    occupancyChart: '셀 점유율 기록',
    periodSelector: {
      last30Days: '최근 30일',
      last60Days: '최근 60일',
      last90Days: '최근 90일'
    },
    viewAll: '모두 보기',
    occupancy: '락커 점유율',
    occupancyDescription: '현재 락커 사용 통계',
    usageHistory: '사용 기록',
    usageHistoryDescription: '시간에 따른 패키지 활동',
    period: '기간',
    days7: '7일',
    days30: '30일',
    days90: '90일'
  },
  menu: {
    users: '사용자',
    packages: '패키지',
    settings: '설정'
  },
  users: {
    title: '사용자',
    add: '사용자 추가',
    confirmDelete: '삭제 확인',
    confirmDeleteText: '이 사용자를 삭제하시겠습니까?',
    createSuccess: '사용자가 성공적으로 생성되었습니다',
    createError: '사용자 생성에 실패했습니다',
    phoneExists: '이 전화번호를 가진 사용자가 이미 존재합니다',
    deleteSuccess: '사용자가 성공적으로 삭제되었습니다',
    deleteError: '사용자 삭제에 실패했습니다',
    communities: '커뮤니티',
    search: '이름으로 검색',
    communityFilter: '커뮤니티별 필터',
    statusFilter: '상태별 필터',
    createTitle: '사용자 생성',
    editTitle: '사용자 편집',
    email: '이메일',
    phone: '전화번호',
    fullName: '전체 이름',
    firstName: '이름',
    lastName: '성',
    password: '비밀번호',
    passwordHint: '변경하지 않으려면 비워두세요',
    role: '역할',
    status: '상태',
    coinBalance: '코인 잔액',
    isActive: '활성 사용자',
    dateJoined: '가입 날짜',
    actions: '작업',
    edit: '편집',
    delete: '삭제',
    statuses: {
      active: '활성',
      inactive: '비활성'
    },
    topupBalance: '잔액 충전',
    topupFor: '잔액 충전 대상',
    coinsAmount: '코인 수량',
    topupSuccess: '잔액이 성공적으로 충전되었습니다',
    topupError: '잔액 충전에 실패했습니다'
  },
  packages: {
    title: '패키지',
    add: '추가',
    search: '검색',
    statusFilter: '상태 필터',
    typeFilter: '유형 필터',
    id: 'ID',
    device: '장치',
    cell: '셀',
    sender: '발신자',
    recipient: '수신자',
    type: '유형',
    status: '상태',
    details: '세부사항',
    detailsTitle: '패키지 세부사항',
    createdAt: '생성일',
    expiresAt: '만료일',
    price: '가격',
    courier: '배송원',
    basicInfo: '기본 정보',
    contactInfo: '연락처 정보',
    locationInfo: '위치 정보',
    phone: '전화번호',
    community: '커뮤니티',
    notFound: '패키지를 찾을 수 없습니다',
    notFoundText: '찾고 계신 패키지가 존재하지 않거나 삭제되었습니다.',
    backToList: '패키지 목록으로 돌아가기',
    actions: '작업',
    allCommunities: '모든 커뮤니티',
    statuses: {
      all: '모든 상태',
      new: '새로운',
      locked: '잠김',
      finished: '완료됨',
      canceled: '취소됨',
      expired: '만료됨'
    },
    types: {
      delivery: '배송',
      storage: '보관',
      shared: '공유'
    },
    eventsHistory: '이벤트 기록',
    eventTypes: {
      cell_was_opened: '셀이 열렸습니다',
      cell_was_closed: '셀이 닫혔습니다',
      parcel_created: '패키지가 생성되었습니다',
      parcel_updated: '패키지가 업데이트되었습니다',
      parcel_expired: '패키지가 만료되었습니다',
      parcel_finished: '패키지가 완료되었습니다',
      parcel_canceled: '패키지가 취소되었습니다',
      cell_photo_was_received: '사진'
    },
    statusAll: '모두',
    statusLocked: '활성',
    statusExpired: '만료됨',
    statusFinished: '완료됨',
    dateFilter: '생성일별 필터',
    startDateFilter: '시작일',
    endDateFilter: '종료일'
  },
  settings: {
    title: '설정',
    profileInfo: '프로필 정보',
    appSettings: '애플리케이션 설정',
    email: '이메일',
    fullName: '전체 이름',
    notSpecified: '지정되지 않음',
    role: '역할',
    language: '시스템 언어',
    dateJoined: '가입 날짜',
    theme: '테마',
    roles: {
      administrator: '관리자',
      manager: '매니저',
      customer: '고객'
    },
    notifications: {
      email: '이메일 알림',
      sms: 'SMS 알림'
    },
    save: '설정 저장',
    tariffs: '요금',
    noTariffsData: '요금 정보를 사용할 수 없습니다',
    freeMinutes: '무료 시간',
    pricePerHour: '시간당 가격'
  },
  common: {
    cancel: '취소',
    confirm: '확인',
    create: '생성',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    add: '추가',
    search: '검색',
    filter: '필터',
    reset: '재설정',
    loading: '로딩 중...',
    noData: '데이터가 없습니다',
    unknownUser: '알 수 없는 사용자',
    copied: '{field}이(가) 클립보드에 복사되었습니다',
    copyError: '클립보드에 복사할 수 없습니다',
    close: '닫기',
    error: '오류',
    success: '성공',
    warning: '경고',
    info: '정보',
    ok: '확인',
    pagination: {
      showing: "표시 중",
      of: "중",
      perPage: "페이지당"
    }
  },
  validation: {
    required: '필수 필드',
    phone: '국제 형식으로 번호를 입력하세요',
    minLength: '최소 길이: {min}자',
    maxLength: '최대 길이: {max}자',
    minValue: '최소값: {min}',
    maxValue: '최대값: {max}'
  },
  locker: {
    title: 'Community Locker',
    slogan: '커뮤니티와 쉽게 택배를 맡기고, 받고, 공유하세요. 줄 서기 없음, 번거로움 없음 — 손끝에서 간단하고 안전한 배송만 있습니다.',
    downloadTitle: '앱 다운로드',
    appStore: 'App Store 에서 받기',
    googlePlay: 'Google Play에서 받기',
    copyright: '© 2025. 모든 권리 보유.'
  },
  pickup: {
    title: '패키지 픽업',
    description: '아래 QR 코드를 스캔하여 락커에서 패키지를 픽업하세요.',
    code: '패키지 코드',
    qrCodeAlt: '패키지 픽업용 QR 코드',
    generating: 'QR 코드 생성 중...',
    download: 'QR 코드 다운로드'
  }
} 